import React, { useState, useRef } from "react";
import Slick from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home1 from "../Hero1/Hero1";
import Home2 from "../Hero2/Hero2";
import "./SliderHero.css";

const SliderHero = () => {
  const [active, setActive] = useState(0);
  const slider = React.useRef(null);

  const NextArrow = () => {
    return (
      <span className="next" onClick={() => slider?.current?.slickPrev()}>
        NEXT
      </span>
    );
  };
  const PrevArrow = () => {
    return (
      <span className="prev" onClick={() => slider?.current?.slickNext()}>
        
      </span>
    );
  };

  const prevFun = () => {

  }
  const settings = {
    infinity: true,
    lazyLoad: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: 0,
    beforeChange: (current, next) => setActive(next),
  };
  return (
    <div className="carousel">
      <Slick ref={slider} {...settings}>
        <div className={active === 0 ? "slide activeSlide" : "slide position"}>
          <Home1 next={() => slider?.current?.slickNext()} />
        </div>

        <div className={active === 1 ? "slide activeSlide" : "slide position"}>
          <Home2 next={() => slider?.current?.slickNext()} />
        </div>
      </Slick>
    </div>
  );
};

export default SliderHero;
